// extracted by mini-css-extract-plugin
export default {"itemTitle":"MqzkdfNt"};